// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3i0WK","item":"PaymentsMobile_item__1JDuY","label":"PaymentsMobile_label__3lk-F","amount":"PaymentsMobile_amount__1PTwo"};